// Explicit VaForm editors and custom/inline editors marked data-session-form.
export function hasVisibleEditingForm(doc = typeof document === 'undefined' ? null : document, view = typeof window === 'undefined' ? null : window) {
  if (!doc || !view) return false
  return Array.from(doc.querySelectorAll('.va-form, [data-session-form]'))
    .some(element => element.getAttribute?.('data-session-ignore') !== 'true' && element.getClientRects().length > 0 &&
      !['hidden', 'collapse'].includes(view.getComputedStyle(element).visibility))
}
